(() => {
  const config = document.querySelector('script[data-max-cash-root]');
  if (!config || window.maxCashCheckoutInstalled) return;
  window.maxCashCheckoutInstalled = true;
  const root = config.dataset.maxCashRoot || '/';
  const endpoint = root + 'apps/max-cash?checkout=1';
  const resumeKey = 'max-cash-resume-checkout';
  let busy = false, bypass = false;
  const readResume = () => { try { return Number(sessionStorage.getItem(resumeKey)); } catch { return 0; } };
  const clearResume = () => { try { sessionStorage.removeItem(resumeKey); } catch {} };
  async function read(url, options) {
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(20000),...options});
    if (!response.ok) throw new Error('rewards_unavailable');
    return response.json();
  }
  function problem(proceed, retry) {
    const dialog = document.createElement('dialog');
    dialog.setAttribute('aria-label', 'MAX Cash');
    dialog.innerHTML = '<h2>MAX Cash is still being checked</h2><p>Your rewards have not been lost. You can retry, or continue to checkout with any credit already available there.</p><button type="button" data-retry>Try again</button> <button type="button" data-continue>Continue to checkout</button>';
    dialog.style.cssText = 'max-width:440px;padding:28px;border:1px solid #ccc;border-radius:16px';
    document.body.append(dialog);
    dialog.querySelector('[data-retry]').onclick = () => {dialog.close();dialog.remove();void retry();};
    dialog.querySelector('[data-continue]').onclick = () => {dialog.close();dialog.remove();proceed();};
    dialog.addEventListener('close', () => dialog.remove(), {once:true});
    dialog.showModal();
  }
  async function checkout(proceed) {
    if (busy) return;
    busy = true;
    document.documentElement.setAttribute('aria-busy', 'true');
    try {
      // Finish the original submit event before resubmitting a wholesale form.
      await new Promise(resolve=>setTimeout(resolve,0));
      if (config.dataset.wholesale === 'true') {clearResume();proceed();return;}
      // Retail guests can checkout without entering the member reward flow.
      if (config.dataset.signedIn !== 'true') {clearResume();proceed();return;}
      const cart = await read(root + 'cart.js');
      if (!cart.item_count || cart.currency !== 'CAD') {clearResume();proceed();return;}
      const digest = await crypto.subtle.digest('SHA-256',new TextEncoder().encode(cart.token));
      const cartKey = Array.from(new Uint8Array(digest),v=>v.toString(16).padStart(2,'0')).join('');
      const form = new URLSearchParams({cartKey,totalCents:String(cart.total_price),currency:cart.currency});
      const quote = await read(endpoint + '&' + form);
      if (quote.state === 'login') {
        try {sessionStorage.setItem(resumeKey,String(Date.now()));} catch {}
        location.assign(root + 'customer_authentication/login?return_to=' + encodeURIComponent(root + 'cart'));
        return;
      }
      clearResume();
      if (['wholesale','unlinked','unsupported_currency'].includes(quote.state)) {proceed();return;}
      if (quote.state !== 'quoted') throw new Error('rewards_unavailable');
      form.set('issued',quote.issued);form.set('csrf',quote.csrf);
      const result = await read(endpoint,{method:'POST',body:form});
      if (!['ready','wholesale','unlinked','unsupported_currency'].includes(result.state)) throw new Error('rewards_pending');
      proceed();
    } catch {problem(proceed,()=>checkout(proceed));}
    finally {busy=false;document.documentElement.removeAttribute('aria-busy');}
  }
  document.addEventListener('submit', event => {
    if (bypass) {bypass=false;return;}
    const button=event.submitter,form=event.target;
    if (!button || button.name !== 'checkout' || !form.action || new URL(form.action,location.href).pathname.replace(/\/$/,'').split('/').pop() !== 'cart') return;
    event.preventDefault();event.stopImmediatePropagation();
    void checkout(()=>{bypass=true;form.requestSubmit(button);bypass=false;});
  },true);
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url=new URL(link.href,location.href);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();
    void checkout(()=>location.assign(link.href));
  },true);
  if (config.dataset.wholesale !== 'true') {
    const decorate=()=>{if(config.dataset.signedIn !== 'true') return; document.querySelectorAll('button[name="checkout"]').forEach(button=>{
      if (button.dataset.maxCashNotice) return;
      button.dataset.maxCashNotice='true';
      const note=document.createElement('p');
      note.className='caption';note.textContent='MAX Cash members: choose Apply store credit at checkout to use your rewards. Use this checkout button for MAX Cash.';
      button.parentNode.insertBefore(note,button);
    });};
    decorate();new MutationObserver(decorate).observe(document.body,{childList:true,subtree:true});
  }
  const resumed=readResume();
  if (config.dataset.signedIn === 'true' && resumed>0 && Date.now()-resumed<600000) {
    clearResume();
    const button=document.querySelector('button[name="checkout"]');
    if (button?.form) button.form.requestSubmit(button);
  }
})();
